import { CoreWalker } from "../../../../core/Walker";
export class MissingReference {
  constructor(param, path) {
    this.param = param;
    this.path = path;
  }
  absolutePath() {
    return CoreWalker.makeAbsolutePath(this.param.node, this.path);
  }
  matchesPath(path) {
    return this.absolutePath() == path;
  }
  resolveMissingDependencies() {
    const input = this.param.rawInputSerialized();
    this.param.set(this.param.defaultValue());
    this.param.set(input);
  }
}
